import { inject, Injectable } from "@angular/core";
import { filter, map, Observable, switchMap } from "rxjs";
import { TICKET_TYPE } from 'src/app/core/enums/ticket-type.enum';
import { Ticket } from "../../domain/model/ticket.model";
import { TICKET_REPOSITORY } from "../../domain/tokens/ticket.token";

@Injectable({ providedIn: 'root' })
export class GetAccountInvoiceUseCase {
  private readonly ticketRepository = inject(TICKET_REPOSITORY);

  execute(accountId: string): Observable<Ticket> {
    return this.ticketRepository.getTicketBySearch({
      queryParams: {
        accountId
      },
    }).pipe(
      filter((tickets) => tickets?.length > 0),
      map((tickets) => this.findMostRecentSimpleTicket(tickets)),
      switchMap((ticket) => this.persistTicket(ticket))
    );
  }

  private findMostRecentSimpleTicket(tickets: Ticket[]): Ticket {
    const simpleTickets = tickets.filter(ticket => ticket.type === TICKET_TYPE.simple);
    
    if (simpleTickets.length === 0) {
      return tickets[0];
    }

    const mostRecentTicket = simpleTickets.reduce((mostRecent, current) => {
      return current.updatedAt > mostRecent.updatedAt ? current : mostRecent;
    });

    return mostRecentTicket;
  }

  private persistTicket(ticket: Ticket): Observable<Ticket> {
    return this.ticketRepository.saveTicket(ticket);
  }
}